import React from 'react';
import Link from 'react-router/lib/Link';
import { t } from '../../../../../modules/infra/i18n';
import * as shapes from '../shapes';
import { formatDiscount } from '../helpers';

const Item = ({ discount, baseUrl, disabled, currency }) => {
  // Map assignment values to translation keys
  const getAssignmentText = (assignment) => {
    const assignmentMap = {
      products: t('settings:discounts.assignment.products'),
      services: t('settings:discounts.assignment.services'),
    };

    return assignmentMap[assignment] || t('settings:discounts.assignment.all');
  };

  if (disabled) {
    return (
      <div className="c-table-card__row">
        <div className="c-table-card__cell">{discount.name}</div>
        <div className="c-table-card__cell">{formatDiscount(discount, currency)}</div>
        <div className="c-table-card__cell">{getAssignmentText(discount.assignment)}</div>
      </div>
    );
  }

  return (
    <Link className="c-table-card__row" to={`${baseUrl}/${discount.id}/edit`}>
      <div className="c-table-card__cell">{discount.name}</div>
      <div className="c-table-card__cell">{formatDiscount(discount, currency)}</div>
      <div className="c-table-card__cell">{getAssignmentText(discount.assignment)}</div>
    </Link>
  );
};

Item.propTypes = {
  discount: shapes.discount.isRequired,
  baseUrl: shapes.url.isRequired,
  disabled: shapes.flag.isRequired,
  currency: shapes.string.isRequired,
};

export default Item;
